module.exports = "<dl class=\"form-element\">\n    <dt>\n        <label>{{ SelectCustomFieldFormCtrl.field.label }}</label>\n    </dt>\n    <dd>\n        <select\n            ng-class=\"SelectCustomFieldFormCtrl.isFullWidth ? 'full-width' : ''\"\n            name=\"{{ SelectCustomFieldFormCtrl.field.label }}\"\n            ng-model=\"SelectCustomFieldFormCtrl.field.value\"\n            ng-options=\"option for option in SelectCustomFieldFormCtrl.field.field_options\"\n        ></select>\n    </dd>\n</dl>\n";


//////////////////
// WEBPACK FOOTER
// ./src/app/components/issues/issue_forms/fragments/custom_fields/select/select.html
// module id = 668
// module chunks = 0